import gql from 'graphql-tag';
import {baseResponse} from 'src/app/store/base.graphql';

export const requirementsFields = `
  id
  requirementUniqueId
  requirementName
  requirementDescription
`;

export const CREATE_SERVICE_REQUIREMENT = gql`
  mutation CreateServiceRequirementMutation($input: ServiceRequirementInputObjects) {
    createServiceRequirementMutation(input: $input) {
      data{
        ${requirementsFields}
      }
      response{
        ${baseResponse}
      }
    }
  }
`;

export const UPDATE_SERVICE_REQUIREMENT = gql`
  mutation UpdateServiceRequirementGroupMutation($input: ServiceRequirementGroupInputObjects) {
    updateServiceRequirementGroupMutation(input: $input) {
      data{
        ${requirementsFields}
      }
      response{
        ${baseResponse}
      }
    }
  }
`;

export const GET_SERVICE_REQUIREMENTS = gql`
  query GetServiceRequirements($groupUniqueId: String) {
    getServiceRequirements(groupUniqueId: $groupUniqueId) {
      data{
        ${requirementsFields}
      }
      response{
        ${baseResponse}
      }
    }
  }
`;

export const DELETE_SERVICE_REQUIREMENT = gql`
  mutation DeleteServiceRequirementMutation($requirementUniqueId: String!) {
    deleteServiceRequirementMutation(requirementUniqueId: $requirementUniqueId) {
      response{
        ${baseResponse}
      }
    }
  }
`;
